import {
    EventEmitter
} from "events";
import TCVelikClient from '@/TCVelikClient/TCVelikClient.js'

class WorkflowService extends EventEmitter {
    GetWorkflows() {
        var url = "/api/workflow/get";
        return TCVelikClient.GetRelative(url);
    }
}

export default new WorkflowService();
